import Image from 'next/image';

const ResponsiveImage = ({ src, className, alt }) => {
  return (
    <div className="image-container">
      <Image layout="fill" src={src} alt={alt} className={`image ${className}`} />
    </div>
  );
};

module.exports = ResponsiveImage;
